<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-form @submit.stop.prevent="onSubmit">
        <v-text-field
          class="mr-6"
          v-model="search"
          :label="$i18n.translate('Filter') + ' ' + $i18n.translate(title)"
          flat
          solo-inverted
          hide-details
          clearable
          clear-icon="mdi-close-circle-outline"
          @click:clear="onClear"
        ></v-text-field>
      </v-form>
      <v-btn fab small :to="{ name: 'ruleFormula', params: { id: 0 } }">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :server-items-length="total"
        :options.sync="options"
        :loading="loading"
      >
        <template v-slot:item.name="{ item }">
          <router-link :to="{ name: 'ruleFormula', params: { id: item.id } }">
            {{ item.name }}
          </router-link>
        </template>
        <template v-slot:item.updatedDate="{ item }">
          {{ item.updatedDate | formatDateFromNow }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon v-if="$privilege.hasPrivilege('RULE_FORMULA_DELETE')" @click="onDeleteConfirm(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-dialog v-model="deleteConfirm" max-width="500">
        <v-card>
          <v-card-title>
            Delete this rule formula?
          </v-card-title>
          <v-card-text v-if="deleteConfirmItem">
            <b>{{ title }}</b
            >: {{ deleteConfirmItem.name }}
          </v-card-text>

          <v-card-actions
            ><v-spacer></v-spacer><v-btn class="primary" @click="onDelete(deleteConfirmItem)">Yes</v-btn
            ><v-btn @click="onDeleteCancel()">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RuleFormulas",
  props: {
    title: {
      type: String,
      default: "Rule Formulas"
    }
  },
  metaInfo() {
    return {
      title: this.title
    };
  },
  data() {
    return {
      loading: false,
      items: [],
      nameFilter: "",
      search: "",
      filterByEffective: "Active",
      effectiveItems: [
        { text: "Active", value: "Active" },
        { text: "Inactive", value: "Inactive" },
        { text: "All", value: "All" }
      ],
      headers: [
        {
          value: "name",
          text: "Name",
          sortable: true
        },
        {
          value: "ruleCondition.spelExpression",
          text: "Expression",
          sortable: true
        },
        {
          value: "updatedDate",
          text: "Last Updated",
          sortable: true
        },
        {
          value: "actions",
          text: "",
          align: "center",
          sortable: false,
          show: false
        }
      ],
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["updatedDate"],
        sortDesc: [true]
      },

      deleteConfirm: false,
      deleteConfirmItem: null
    };
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    }
  },
  methods: {
    onSubmit() {
      if (this.options.page !== 1) {
        this.options.page = 1;
      } else {
        this.getData();
      }
    },
    getData() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let filters = {};
      if (this.search && this.search.trim().length > 0) {
        filters.keyword = this.search.trim();
      }

      this.$api
        .post(
          "/api/ruleFormulas/search?size=" +
            itemsPerPage +
            "&page=" +
            (page - 1) +
            (sortBy && sortBy.length > 0
              ? "&sort=" + sortBy[0] + "," + ((sortDesc && sortDesc.length > 0) & sortDesc[0] ? "DESC" : "ASC")
              : ""),
          filters
        )
        .then(({ data }) => {
          this.loading = false;
          this.items = data.content;
          this.total = data.totalElements;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    onDeleteConfirm(item) {
      this.deleteConfirmItem = item;
      this.deleteConfirm = true;
    },
    onDeleteCancel() {
      this.deleteConfirmItem = null;
      this.deleteConfirm = false;
    },
    onDelete(item) {
      this.errors = {};
      this.loading = true;
      return this.$api
        .delete("/api/ruleFormulas/" + item.id + "/delete")
        .then(() => {
          this.getData();
        })
        .catch(error => {
          this.errors = this.$api.getErrorsFromResponse(error);
        })
        .finally(() => {
          this.onDeleteCancel();
          this.loading = false;
        });
    },
    onClear() {
      this.search = "";
      this.onSubmit();
    }
  },
  mounted() {
    this.$store.dispatch("setBreadcrumb", [
      {
        text: this.$i18n.translate("Dashboard"),
        to: { name: "dashboard" },
        exact: true
      },
      {
        text: this.$i18n.translate("Clients"),
        to: { name: "clients" },
        exact: true
      },
      {
        text: this.selectedClient.name,
        to: {
          name: "client",
          params: { id: this.selectedClient.id },
          exact: true
        }
      },
      {
        text: this.$i18n.translate("Programs"),
        to: { name: "programs" },
        exact: true
      },
      {
        text: this.selectedProgram.name,
        to: {
          name: "program",
          params: { id: this.selectedProgram.id },
          exact: true
        }
      },
      { text: this.title }
    ]);
  },
  computed: {
    ...mapGetters(["selectedClient", "selectedProgram"])
  }
};
</script>
